import Vue from 'vue'

Vue.filter('priceLocaleString', function(value) {
    if(typeof value == "number") {
        return "¥"+value.toLocaleString();
    } else {
        return value;
    }
});
Vue.filter('percentDisp', function(value) {
    if(typeof value == "number") {
        return value+"%";
    } else {
        return value;
    }
});
